/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card } from "@";
import { useWatch } from "react-hook-form";
import { ThemeGallery } from "@/features/website/themes/components/theme-gallery";

interface Props {
  setValue: any;
  control: any;
  errors: any;
  show?: string | undefined;
}

export const ThemeSelectionSection = ({
  setValue,
  control,
  errors,
  show,
}: Props) => {
  const themeId = useWatch({ control, name: "themeId" }) as number | null;

  return (
    <Card title="اختيار الثيم">
      <p className="mb-3 text-xs text-gray-500 dark:text-gray-400">
        اختر القالب البصري الذي سيُستخدم لعرض صفحة الهبوط للزوار.
      </p>

      <ThemeGallery
        value={themeId}
        onChange={(id) =>
          setValue("themeId", id, { shouldDirty: true, shouldValidate: true })
        }
        disabled={!!show}
        error={errors?.themeId?.message}
      />
    </Card>
  );
};
